const { REACT_APP_API_URL: API } = process.env;

const getAPI = () => {
  return API;
};

export const getToken = () => {
  return localStorage.getItem('ishara');
};

export const user = (withToken = false) => {
  const query = withToken ? `?token=${getToken()}`: '' ;
  return `${getAPI()}/api/v1/user${query}`;
};


export const extraUser = () => {
  return `${getAPI()}/api/v1/user/extra`;
};

export const ticket = (withToken = false) => {
  const query = withToken ? `?ishara=${getToken()}`: '' ;
  return `${getAPI()}/api/v1/ticket${query}`;
};

export const isStart = () => {
  return `${getAPI()}/api/v1/is-starting`;
};

export const winner = (withToken = false) => {
  const query = withToken ? `?ishara=${getToken()}`: '' ;
  return `${getAPI()}/api/v1/winner${query}`;
};

export const loser = (withToken = false) => {
  const query = withToken ? `?ishara=${getToken()}`: '' ;
  return `${getAPI()}/api/v1/loser${query}`;
};

export const isWinner = () => {
  return `${getAPI()}/api/v1/winner/is-win`;
};

export const haveTicket = () => {
  return `${getAPI()}/api/v1/user/have-ticket?ishara=${getToken()}`;
};

export const winnerList = () => {
  return `${getAPI()}/api/v1/winner/list`;
};